(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5634],{

/***/ 69044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/vinted-restricted-items/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-06-23",
      tag: "Vinted",
      title: "Vinted Restricted Items: The prohibited products you should never list",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted started as a reselling platform for second-hand clothing for women, men, and kids. Over the years, the categories expanded to include home, entertainment, and pet care items."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If it\u2019s your first time selling on Vinted or considering listing things other than apparel on this platform, take the time to know what you can and cannot sell. It\u2019s always better to be compliant than to assume a \u201Cwait and see\u201D approach \u2013 determining if an item is allowed to be sold if the listing gets taken down or not \u2013 as this may result in violation or even account suspension if done repeatedly.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Let\u2019s start with the ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "safe items to sell on Vinted"
        }), ". The green flag is on for the following products:"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Clothing, footwear, and accessories for women, men, and children"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "New/unused cosmetics,beauty, and grooming products"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Headphones, mobile phone cases, smartwatches, and other related tech accessories."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tableware, home d\xE9cor, soft furnishings, and other accessories for the home"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Game consoles, video games, books, puzzles, board games, music-related items, and other forms of entertainment"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Please note that the list above serves as a guide only. Vinted reserves the right to remove listings that are offensive, dangerous, or don\u2019t reflect the values of the platform. For instance, although video games and books are generally allowed, their themes or contents should not promote pornography."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Whenever applicable, include manuals, care instructions, and safety warnings to protect your buyers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What are the prohibited items on Vinted?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As with the earlier disclaimer, the list below is not exhaustive and is meant only as a guide. It is advisable to reach out to Vinted directly if you need help clarifying a gray area."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The red flag is on for the following products, which are grouped into three main categories:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Strictly prohibited items."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Items that do not comply with hygiene standards or pose a risk to one\u2019s health."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Items that are not related to the allowed categories or simply do not align with the Vinted vision."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In this article, we will be discussing the main ideas behind each category. For the complete and detailed rundown of the items under these categories, please refer to Vinted\u2019s", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://www.vinted.com/catalog-rules",
          children: "Catalog Rules"
        }), ".", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["1.", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: " Strictly Prohibited Items."
        }), " These are the non-negotiable off-limit products that will be removed from the marketplace at all times."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Items that violate applicable laws and intellectual property rights"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Items that promote violence, incite hate and discrimination, and suggest terrorism, such as firearms and weapons. This also includes official uniforms and accessories belonging to the armed forces, the police and emergency services, and the Nazis.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Items that promote child and adult pornography"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "All kinds of drugs, drug paraphernalia, and tobacco products, including e-cigarettes and vaping instruments."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free or promotional items that are not meant to be sold separately (e.g., testers and \u201CBeauty Boxes\u201D). Video games that come with loot boxes are also prohibited."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Counterfeits"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Unsafe, hazardous, defective items ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://www.recalls.gov/",
            children: "recalled by the government"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "All kinds of food and drink"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["2.", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: " Items that do not comply with hygiene standards or pose a risk to one\u2019s health."
        }), " The rule of thumb is to list only unworn, unused items and generally veer away from intimate items (i.e., involve close skin contact and used for delicate areas of the body)."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted allows certain worn items under this category provided they are declared as such, still in good condition, and thoroughly cleaned before listing."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "All kinds of second-hand underwear. If listing new underwear, you must include photos of the packaging and the attached hang tags (not just the brand labels and wash care guide tags)."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Worn brassieres, swimsuits, socks, and tights are accepted as long as these are properly washed and the condition is clearly stated in the description."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Make-up and various applicators like brushes and sponges, perfumes, and skincare and haircare products that were already opened and used (even once). These should come with sealed packaging. In listing new items under this category, include clear photos that show the packaging and helpful information such as ingredients list and bar code, which may reveal details like date and place of production."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Homemade cosmetics and skincare or grooming products, especially those including sensitive or regulated ingredients and formulations such as sunscreen and pimple treatments)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Used piercing studs and similar accessories for the eyebrow, tongue, lip, nose, and other intimate areas"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Contact lenses, solutions, and eyewear cases. Period products such as sanitary napkins and menstrual cups.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Used towels and all kinds of beddings. You may list new items provided you include clear photos of the tags, original packaging, and other proof of its pristine condition."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Used baby and children\u2019s beddings, feeding bottles, nursing equipment, chew toys and dummies, carriers and wraps, and related items."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["3.", /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
          children: [' ', "Items that are either not clothing, do not relate to fashion, beauty, accessorizing, children, or simply do not align with the Vinted vision."]
        }), ' ', "Various items fit into this category, and we will group similar ones. Again, you may refer", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://www.vinted.com/catalog-rules",
          children: "here"
        }), " for the complete list."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Items containing animal fur, reptile skin, shells, or ivory are not allowed. On the other hand, you may list items made of or containing leather, cashmere, wool, and mohair."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Gadgets and electronic devices not covered under the Entertainment category: mobile phones, laptops, kitchen appliances, PC components, and similar items."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Sports and fitness equipment (e.g., weights, snowboards, yoga mats) may not be listed. However, sports-related clothing and protective accessories are allowed."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Furniture for adults (only for kids are allowed), garden tools, home-improvement equipment, and tools that require power. Mattresses and bed pillows are not allowed, except for decorative or throw pillows."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Cookware, kitchen utensils, disposable tableware, and cutlery made of paper or plastic"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Digital book forms, digital games or coupons, magazines, and stationery supplies are not allowed, as well as any form of art (e.g., paintings, photographs). However, you may list frames."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Non-physical goods such as professional services, event tickets, gift cards, and subscriptions"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Items that are not on hand and listings that do not indicate what the buyers will receive. This includes items on a pre-order basis, sales catalogs, and \u201Csurprise\u201D goods such as mystery boxes and advent calendars. You also cannot sell packaging boxes, shopping bags, and empty dust bags."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Sex toys, fetish-related paraphernalia, and other sexually explicit items"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What happens if a seller violates these rules?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Aside from monitoring the listings, Vinted also empowers its members to alert them in any case of suspicious listings to keep the platform a safe space to buy and sell."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Once a listing gets flagged, the Vinted team reviews the case. If they determine the listing as a prohibited item, they will immediately remove it and inform the seller of the violation."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Depending on the seller's gravity of the offense and previous record, their account may be suspended or even permanently blocked."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Note that if the removed or hidden item is a bumped/promoted listing, the seller will not be refunded the cost of this promotional tool."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Sell safe and smart in different marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Each marketplace has its own set of rules and lists of what's allowed to be traded or not. It is the seller's responsibility to be aware of this to protect their business. Now, if you sell not just on Vinted but on other marketplaces like Poshmark, Mercari, Depop, or eBay, you also need to know their respective prohibited items."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Although being present on several platforms may seem daunting, it provides your listings with much more exposure, that's crucial in making sales. Managing your listings in multiple marketplaces need not be confusing and time-consuming."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop has smart automation functions and advanced capabilities to help sellers scale up their business. The app's features include setting goals, tracking sales, and preparing shipping labels using only one app instead of managing them separately on each platform."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Try it now to get first-hand experience on how automation can free up your time. Start your 7-day free trial today by signing up ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "here"
        }), "."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/vinted-restricted-items.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Vinted Restricted Items: The prohibited products you should never list"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Prohibited items come with red flags you must be mindful of to keep your Vinted business in good standing."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/vinted-restricted-items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/vinted-restricted-items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Vinted Restricted Items: The prohibited products you should never list"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Prohibited items come with red flags you must be mindful of to keep your Vinted business in good standing."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-06-23T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-06-23T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Vinted"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 18665:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/vinted-restricted-items",
      function () {
        return __webpack_require__(69044);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(18665); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);